import React from 'react';
import { Sparkles } from 'lucide-react';
import type { UserDetailsResponse } from '../../schemas/validation';

interface UserDetailsHeaderProps {
  user: UserDetailsResponse['data']['user'];
  onEditUser: () => void;
  onBuildWithRoary: () => void;
  isLaunchingRoary?: boolean;
}

export const UserDetailsHeader: React.FC<UserDetailsHeaderProps> = ({
  user,
  onEditUser,
  onBuildWithRoary,
  isLaunchingRoary,
}) => {
  return (
    <div className="bg-white shadow">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="py-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <div className="flex items-center space-x-4">
                <div className="h-12 w-12 rounded-full bg-gradient-to-r from-primary-500 to-primary-600 flex items-center justify-center">
                  <span className="text-lg font-medium text-white">
                    {user.name.charAt(0).toUpperCase()}
                  </span>
                </div>
                <div>
                  <h1 className="text-2xl font-bold text-gray-900 flex items-center space-x-2">
                    <span>{user.name}</span>
                    {user.isAdmin && (
                      <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-purple-100 text-purple-800">
                        Admin
                      </span>
                    )}
                  </h1>
                  <p className="text-gray-600">{user.email}</p>
                </div>
              </div>
            </div>
            <div className="flex items-center space-x-3">
              <button
                onClick={onBuildWithRoary}
                disabled={isLaunchingRoary}
                className="btn btn-ghost text-orange-600 hover:text-orange-700 flex items-center disabled:opacity-50 disabled:cursor-not-allowed"
                title="Mimic this user and open Roary to build them a website"
              >
                <Sparkles size={16} className="mr-1" />
                {isLaunchingRoary ? 'Opening Roary…' : 'Build with Roary'}
              </button>
              <button onClick={onEditUser} className="btn btn-primary">
                Edit User
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
